document.addEventListener("DOMContentLoaded", function () {
  // Get the current path for active state detection
  const currentPath = window.location.pathname;
  console.log("Path atual:", currentPath);
  
  // Process navigation items in header and secondary navigation
  processNavigation("#header-navigation");
  processNavigation("#secondary-navigation");
  
  // Setup mobile navigation dropdown
  setupMobileNavigation();
  
  // Function to process navigation and mark active items
  function processNavigation(navSelector) {
    const navItems = document.querySelectorAll(`${navSelector} .nav-group-items`);
    
    // Preparar array para armazenar os items ativos e suas pontuações
    // Uma pontuação maior significa uma correspondência mais específica
    let activeItems = [];
    
    // Primeira passagem: identificar possíveis itens ativos e suas pontuações
    navItems.forEach((item) => {
      const url = item.getAttribute("data-url");
      if (!url) return;
      
      let isActive = false;
      let score = 0;
      
      // Caso especial para a página inicial
      if (url === "/") {
        // Apenas ativo se estivermos exatamente na raiz
        isActive = (currentPath === "/" || currentPath === "/index.html");
        score = isActive ? 1 : 0; // Pontuação mínima para raiz
      } else {
        // Para outros URLs, verificar correspondência exata ou path inicial
        const isExactMatch = url === currentPath;
        const isStartsWithMatch = currentPath.startsWith(url) && 
                                   (currentPath.charAt(url.length) === "/" || url.endsWith("/"));
        
        isActive = isExactMatch || isStartsWithMatch;
        
        // Pontuação baseada na especificidade - URLs mais longos recebem pontuação maior
        if (isActive) {
          score = url.length;
          // Bônus para correspondência exata
          if (isExactMatch) score += 1000;
        }
      }
      
      if (isActive) {
        activeItems.push({ item, score, url });
      }
    });
    
    console.log("Possíveis itens ativos:", activeItems.map(i => i.url));
    
    // Se tivermos múltiplos itens ativos, escolhemos o mais específico (pontuação mais alta)
    if (activeItems.length > 0) {
      // Ordenar por pontuação (maior primeiro)
      activeItems.sort((a, b) => b.score - a.score);
      
      // Selecionar apenas o item com maior pontuação
      const topItem = activeItems[0];
      console.log("Item ativo selecionado:", topItem.url, "com pontuação", topItem.score);
      
      // Aplicar classe ativa apenas ao item com maior pontuação
      topItem.item.classList.add("active");
      const link = topItem.item.querySelector("a");
      if (link) link.classList.add("active");
    }
    
    // Only process grouped navigation for secondary navigation
    if (navSelector === "#secondary-navigation") {
      const groups = {};

      navItems.forEach((item) => {
        const label = item.getAttribute("data-label");
        const url = item.getAttribute("data-url");

        if (!label) return;

        const parts = label.split("|");
        const groupName = parts[0].trim();
        const itemLabel = parts[1] ? parts[1].trim() : parts[0].trim();

        if (!groups[groupName]) {
          groups[groupName] = [];
        }

        // Usar o mesmo algoritmo de detecção de ativo que usamos acima
        let isActive = false;
        
        if (url === "/") {
          isActive = (currentPath === "/" || currentPath === "/index.html");
        } else {
          const isExactMatch = url === currentPath;
          const isStartsWithMatch = currentPath.startsWith(url) && 
                                    (currentPath.charAt(url.length) === "/" || url.endsWith("/"));
          
          isActive = isExactMatch || isStartsWithMatch;
        }
        
        // Se houver múltiplos itens ativos, apenas o mais específico será realmente ativo
        if (isActive && activeItems.length > 0) {
          // Verificar se este item é o de maior pontuação
          isActive = activeItems[0].url === url;
        }

        groups[groupName].push({
          label: itemLabel,
          url: url,
          isActive: isActive
        });
      });

      console.log("Navegação agrupada:", groups);

      // Monta os grupos na navegação
      const navContainer = document.getElementById("secondary-navigation");
      if (!navContainer) return;
      
      navContainer.innerHTML = ""; // Limpa o menu original

      for (const groupName in groups) {
        const groupEl = document.createElement("li");
        groupEl.classList.add("nav-group-items");
        groupEl.innerHTML = `
                <span class="nav-group-title">${groupName}</span>
                <ul class="nav-group-items">
                    ${groups[groupName]
                      .map(
                        (item) => `
                        <li class="nav-group-items ${item.isActive ? 'active' : ''}">
                            <a href="${item.url}" class="${item.isActive ? 'active' : ''}">
                                <span class="nav-text">${item.label}</span>
                            </a>
                        </li>
                    `
                      )
                      .join("")}
                </ul>
            `;
        navContainer.appendChild(groupEl);
      }
    }
  }
  
  // Function to handle mobile navigation dropdown
  function setupMobileNavigation() {
    const mobileFilterIcon = document.querySelector('.mobile-nav-filter-icon');
    const mobileDropdown = document.querySelector('.mobile-nav-dropdown');
    
    if (!mobileFilterIcon || !mobileDropdown) return;
    
    // Toggle dropdown when filter icon is clicked
    mobileFilterIcon.addEventListener('click', function(e) {
      e.stopPropagation();
      mobileDropdown.classList.toggle('show');
    });
    
    // Close dropdown when clicking outside
    document.addEventListener('click', function(e) {
      if (!mobileDropdown.contains(e.target) && !mobileFilterIcon.contains(e.target)) {
        mobileDropdown.classList.remove('show');
      }
    });
    
    // Mark active item in dropdown
    const dropdownItems = mobileDropdown.querySelectorAll('li');
    
    // Preparar array para armazenar os items ativos e suas pontuações
    let activeItems = [];
    
    // Primeira passagem: identificar possíveis itens ativos e suas pontuações
    dropdownItems.forEach((item) => {
      const url = item.getAttribute("data-url");
      if (!url) return;
      
      let isActive = false;
      let score = 0;
      
      // Caso especial para a página inicial
      if (url === "/") {
        // Apenas ativo se estivermos exatamente na raiz
        isActive = (currentPath === "/" || currentPath === "/index.html");
        score = isActive ? 1 : 0; // Pontuação mínima para raiz
      } else {
        // Para outros URLs, verificar correspondência exata ou path inicial
        const isExactMatch = url === currentPath;
        const isStartsWithMatch = currentPath.startsWith(url) && 
                                   (currentPath.charAt(url.length) === "/" || url.endsWith("/"));
        
        isActive = isExactMatch || isStartsWithMatch;
        
        // Pontuação baseada na especificidade - URLs mais longos recebem pontuação maior
        if (isActive) {
          score = url.length;
          // Bônus para correspondência exata
          if (isExactMatch) score += 1000;
        }
      }
      
      if (isActive) {
        activeItems.push({ item, score, url });
      }
    });
    
    console.log("Possíveis itens ativos (mobile):", activeItems.map(i => i.url));
    
    // Se tivermos múltiplos itens ativos, escolhemos o mais específico (pontuação mais alta)
    if (activeItems.length > 0) {
      // Ordenar por pontuação (maior primeiro)
      activeItems.sort((a, b) => b.score - a.score);
      
      // Selecionar apenas o item com maior pontuação
      const topItem = activeItems[0];
      console.log("Item ativo selecionado (mobile):", topItem.url, "com pontuação", topItem.score);
      
      // Aplicar classe ativa apenas ao item com maior pontuação
      topItem.item.classList.add("active");
      const link = topItem.item.querySelector("a");
      if (link) link.classList.add("active");
    }
  }
});
